// Swiper initialization with autoplay delay from data-autoplay-delay
window.addEventListener("DOMContentLoaded", function() {
  if (!window._sliderInit) {
    window._sliderInit = true;
    var sliders = document.querySelectorAll(".swiper");
    var sliderCache = {};
    window.sliderCache = sliderCache;
    sliders && sliders.forEach(function(swiperEl) {
      var s = parseInt(swiperEl.dataset.slides || "1") || 1;
      var i = swiperEl.dataset.carouselId || ("carousel-" + Math.floor(1e3 * Math.random()));
      // Get autoplay delay from data attribute (in seconds, convert to ms)
      var autoplayDelay = parseInt(swiperEl.getAttribute('data-autoplay-delay'));
      var autoplayConfig = false;
      if (!isNaN(autoplayDelay)) {
        autoplayConfig = { delay: autoplayDelay * 1000 }; // Convert to milliseconds
      }
      sliderCache[i] = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
          768: {
            slidesPerView: s || 1,
            spaceBetween: s ? 10 : 0
          }
        },
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplay: autoplayConfig,
        on: {
          slideChangeTransitionEnd: function(swiper) {
            var t = swiper.slides[swiper.activeIndex];
            var s = t.closest("card-body");
            if (!s) return;
            var i = t.dataset.showCard;
            s.querySelectorAll("[data-card-id").forEach(function(e) { e.classList.add("hidden"); });
            s.querySelector('[data-card-id="' + i + '"]').classList.remove("hidden");
          }
        }
      });
    });
    
    // Event listeners for carousel markers
    var carouselMarkers = document.querySelectorAll(".carousel-marker li a");
    if (carouselMarkers) {
      carouselMarkers.forEach(function(marker) {
        marker.addEventListener("mouseenter", function(event) {
          event.preventDefault();
          if (event.target.nodeName === "A") {
            var target = event.target;
            var carouselId = marker.closest("ul.carousel-marker").dataset.for;
            var carousel = sliderCache[carouselId];
            if (carousel) {
              var slideIndex = parseInt(target.dataset.showSlide);
              carousel.slideTo(slideIndex, 200, false);
            }
            marker.closest("ul.carousel-marker").querySelectorAll("li").forEach(function(li) {
              li.classList.remove("active");
            });
            var activeMarker = marker.closest("li");
            if (activeMarker) activeMarker.classList.add("active");
          }
        });
      });
    }
    
    // Event listeners for card show buttons
    document.querySelectorAll("[data-show-card]").forEach(function(button) {
      button.addEventListener("click", function(event) {
        event.preventDefault();
        var carouselId = button.closest(".swiper").dataset.carouselId;
        var cardId = button.dataset.showCard;
        var cardBody = button.closest("card-body");
        cardBody.querySelectorAll("[data-card-id").forEach(function(card) { 
          card.classList.add("hidden"); 
        });
        cardBody.querySelector('[data-card-id="' + cardId + '"]').classList.remove("hidden");
      });
    });
  }
});